var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('div',{staticClass:"page-body"},[_c('app-menu',{staticClass:"default-app-menu",class:{ reduced: _vm.reducedMenu }}),_c('div',{staticClass:"page-content"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }